import { atom } from 'recoil';

const localStorageEffect =
  (key: string) =>
    ({ setSelf, onSet }: { setSelf: Function; onSet: Function }) => {
      const savedValue = localStorage.getItem(key);
      if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
      }

      onSet((newValue: string, _: {}, isReset: boolean) => {
        isReset ? localStorage.removeItem(key) : localStorage.setItem(key, newValue.toString());
      });
    };

export const isLoggedInState = atom<boolean>({
  key: 'IS_LOGGEDIN',
  default: false,
  effects_UNSTABLE: [localStorageEffect('IS_LOGGEDIN')]
});

export const authTokenState = atom<string>({
  key: 'AUTH_TOKEN',
  default: '',
  effects_UNSTABLE: [localStorageEffect('AUTH_TOKEN')]
});
